import * as yup from '@cld/yup-extra';

export const portalInfoSchema = yup
  .object({
    name: yup.string().required(),
  })
  .from('title', 'name')
  .required();

export type PortalInfoDto = yup.InferType<typeof portalInfoSchema>;
